import { Link } from 'react-router-dom';
import { categories, categoryMap } from '@/mocks/categories';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const categoryNameCache: Record<string, string> = {};
categories.forEach((cat) => {
  categoryNameCache[cat.slug] = cat.name;
});

export function getCategoryName(slug: string): string {
  return categoryNameCache[slug] || slug;
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        <li>
          <Link to="/" className="text-foreground-500 hover:text-primary-500 transition-colors">
            <div className="w-4 h-4 flex items-center justify-center inline-block">
              <i className="ri-home-4-line text-xs"></i>
            </div>
            <span className="ml-1">首页</span>
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            <span className="text-foreground-400 mx-1">/</span>
            {item.href ? (
              <Link to={item.href} className="text-foreground-500 hover:text-primary-500 transition-colors">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}